<template>
  <div class="sj-scrollBar" @scroll="handleScroll">
    <div class="sj-scrollBar-list">
      <div
        v-for="(item, index) in data"
        :key="item.value"
        :ref="`item${index}`"
        :class="[
          'sj-scrollBar-item',
          {
            selected: item.value === currentValue
          }
        ]"
        :style="{
          height: `${itemHeight}px`,
          lineHeight: `${itemHeight}px`,
          marginTop: index === 0 ? `${itemHeight * selectedIndex}px` : null,
          marginBottom:
            index === data.length - 1
              ? `${height - itemHeight * (selectedIndex + 1)}px`
              : null
        }"
        @click="handleClick(index, item)"
      >
        {{ item.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    height: {
      type: Number,
      default: 220
    },
    itemHeight: {
      type: Number,
      default: 30
    },
    selectedIndex: {
      type: Number,
      default: 3
    },
    dropdownShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentValue: null,
      debounceFn: null
    };
  },
  created() {
    this.debounceFn = this.debounce(this.emitInput);
  },
  mounted() {
    this.initScroll();
  },
  methods: {
    initScroll() {
      if (!this.$el) return;
      const { value, data, itemHeight } = this;
      let index = 0;
      for (let i = 0; i < data.length; i += 1) {
        if (data[i].value === value) {
          index = i;
        }
      }
      this.$el.scrollTop = itemHeight * index;
      // const refs = this.$refs[`item${index}`];
      // if (refs && refs[0]) {
      //   refs[0].scrollIntoView();
      // }
    },
    handleScroll(e) {
      const { itemHeight, data } = this;
      const { scrollTop } = e.target;
      const itemIndex = Math.ceil(scrollTop / itemHeight);
      if (itemIndex < data.length) {
        this.currentValue = data[itemIndex].value;
        this.debounceFn(itemIndex, data[itemIndex].value);
      }
    },
    // 防抖
    debounce(fn, interval = 400) {
      let timeout = null;

      return (...params) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          fn.apply(this, params);
        }, interval);
      };
    },
    handleClick(index, item) {
      this.emitInput(index, item.value);
    },
    emitInput(index, value) {
      this.$el.scrollTop = this.itemHeight * index;
      // node.scrollIntoView();
      if (this.value !== value) {
        this.$emit("input", value);
        this.$emit("change", value);
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(val) {
        this.currentValue = val;
        this.initScroll();
      }
    },
    dropdownShow(val) {
      if (val) {
        this.$nextTick(() => {
          this.initScroll();
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
@scrollBar-item-height: 30px;

.sj-scrollBar {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  .sj-scrollBar-list {
    text-align: center;
    .text("caption", "available");

    .sj-scrollBar-item {
      text-align: center;
      cursor: pointer;

      &.selected {
        color: @color-highlight;
        background-color: @color-productlight;
      }

      &:hover {
        background-color: @color-productlight;
      }
    }
  }
}
</style>
